import React from 'react'
import ContentLoader, { Rect } from 'react-content-loader/native'
import { white } from '@qirapagos/lib/theme/colors'

interface Props {
  investmentsFlag?: boolean
}

const TransferLimitSkeleton = ({ investmentsFlag }: Props) => (
  <ContentLoader
    speed={3}
    interval={0}
    width="100%"
    height="100vh"
    viewBox="0 0 100% 100vh"
    backgroundColor="#e8e7f7"
    foregroundColor={white}
  >
    <Rect x="5%" y="5vh" rx="8" ry="6" width="80%" height="60%" />
    {investmentsFlag && (
      <Rect x="5%" y="5vh" rx="8" ry="6" width="80%" height="60%" />
    )}
  </ContentLoader>
)

export default TransferLimitSkeleton

TransferLimitSkeleton.defaultProps = {
  investmentsFlag: false
}
